import { Injectable, Type } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { IDialog } from '../directives/dialog.directive';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class DialogService {
    private _dialog = new Subject<{ component: Type<IDialog<any>>; data: any }>();
    get dialog$(): Observable<{ component: Type<IDialog<any>>; data: any }> {
        return this._dialog;
    }
    private _close = new Subject<{}>();
    get close$(): Observable<{}> {
        return this._close;
    }

    constructor(private router: Router) {
        this.router?.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.close();
            }
        });
    }

    open<T, U>(component: Type<IDialog<T>>, data?: T): Observable<U> {
        this._dialog.next({ component, data });
        return this._close.pipe(
            map((value) => value as U),
            first()
        );
    }

    close<T>(value?: T) {
        this._close.next(value);
    }
}
